export const css = {
    root: '_2YUPQw83',
    grouphead: '_2-JyBpsz',
    actions: '_2Rb2zTPs',
    group: '_3LI3xGI5',
    progress: '_2gK30K7O',
    toc: '_3bNdyYTK',
    resource: '_1qIiZ3Vu',
    competencyConnection: '_1dV44efc',
    topicBlock: '_1FQCcUkY',
    titleBlock: '_3yeNkMmS',
    title: '_3d6DNlte',
    close: '_13u6YCYK',
    deck: '_14Wh7lZN',
    refTitleBlock: '_2PvQFdn0',
    complete: '_2kPg7mZq',
    incomplete: 'Vbtat9GT',
    refTitle: '_2SkHF9d0',
    fragment: '_3OlaSbbE',
    readButton: '_1vxZttNf',
    legend: '_1aXHcXx7',
    legendText: '_2IbkRx1h',
    action: '_2FBgdNGr',
    actionIcon: 'OZyRKBk_',
    actionText: '_2Ihq0ICj',
    activitycontent: '_3bjpIvvP',
    videolink: 'P0g83BE9',
    cialink: '_2MV8-jMP',
    ciacontent: '_3KtFheK9',
    resourcecontent: '_32DZ-q8-',
    resourcelink: '_1hPg4D-W',
    scorePill: '_1dSCvB6Z',
    topicAudio: '-h1D2Tkg',
    ' _key': 'apic-theme/apic/micro/book-widgets/topicgroup'
};
export default css;
